import { createSelector } from '@reduxjs/toolkit'
import { AxiosHeaders } from 'axios'
import type { Authentication, AuthenticationErrors, FingerPrint, FingerprintHeader } from '../../../model'
import type { AuthenticationState } from './reducer'
import { ConsumerAppSelector } from '../../store'

export const authenticationStateSelector: ConsumerAppSelector<AuthenticationState> = (state) => state.auth.user

export const authenticationSelector: ConsumerAppSelector<Authentication> = createSelector(authenticationStateSelector, (state) => state.status)

export const fingerprintSelector: ConsumerAppSelector<FingerPrint | null> = createSelector(authenticationStateSelector, (state) => state.fingerprint)

export const fingerprintHeader: ConsumerAppSelector<FingerprintHeader> = createSelector(fingerprintSelector, (fingerprint) => {
  const headers = new AxiosHeaders()
  headers.set('X-Device-Fingerprint', JSON.stringify(fingerprint))
  return headers as FingerprintHeader
})

export const fingerprintHeaderValue: ConsumerAppSelector<string | undefined> = createSelector(fingerprintSelector, (fingerprint) =>
  fingerprint !== null ? JSON.stringify(fingerprint) : undefined
)

export const profilingIdSelector: ConsumerAppSelector<string> = createSelector(authenticationStateSelector, (state) => state?.profilingId ?? '')

export const shouldAllowEmailSelector: ConsumerAppSelector<boolean | undefined> = createSelector(
  authenticationStateSelector,
  (state) => state?.shouldAllowEmail
)

export const errorSelector: ConsumerAppSelector<AuthenticationErrors | undefined> = createSelector(authenticationStateSelector, (state) => state?.error)
